// -----------------------------------------------------------------------------
// PLUGINS/STANDARD
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
import { elt, setClass } from "../util/dom";
export class MenuStandardItem {
    constructor(editor, config) {
        this.editor = editor;
        this.active = config.active;
        this.command = config.command;
        this.dom = elt("div", {
            className: "df-ed-mu__item df-ed-mu__item--clickable",
            onclick: e => {
                e.preventDefault();
                editor.focus();
                this.command(editor.state, editor.dispatch, editor);
            }
        }, config.dom);
    }
    update() {
        let enabled = this.command(this.editor.state, null, this.editor);
        let active = this.active(this.editor.state);
        setClass(this.dom, "df-ed-mu__item--disabled", !enabled && !active);
    }
    active(state) {
        return this.active(state);
    }
    destroy() {
        this.dom.remove();
    }
}
